/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Table, Tag, message, DatePicker, Space, Tooltip, Input } from "antd";
import moment from "moment";
import "./index.scss";
import { serialNum } from "../../utils";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import urls from "../../api/urls";
import API from "../../api";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
const { GET_WALLET_TRANSACTIONS } = urls;
const { RangePicker } = DatePicker;
const Wallet = ({ reloadTable = () => {}, prospayCustomerId }) => {
  const dateFormat_dmy = "YYYY-MM-DD";
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageSize, setTotalPageSize] = useState(0);
  const [filters, setFilters] = useState({});
  const [debouncedFilters, setDebouncedFilters] = useState({});
  const [dateRange, setDateRange] = useState({
    startDate: moment().format(dateFormat_dmy),
    endDate: moment().format(dateFormat_dmy),
  });

  const handleSearch = (value, dataIndex) => {
    const updatedFilters = {
      ...filters,
      [dataIndex]: value?.toString(),
    };

    setFilters(updatedFilters);
    setDebouncedFilters(updatedFilters);
  };

  useEffect(() => {
    if (debouncedFilters && Object.keys(debouncedFilters).length > 0) {
      const handler = setTimeout(() => {
        getTransactions({
          pageNo: pageNum,
          pageSize,
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
          ...debouncedFilters,
        });
      }, 500);
      setPageNum(0);
      setCurrentPage(1);
      return () => clearTimeout(handler);
    }
  }, [debouncedFilters]);

  const getColumnSearchProps = (dataIndex, label = dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          allowClear
          placeholder={`Search ${label || dataIndex}`}
          value={selectedKeys[0] || ""}
          onChange={(e) => {
            const value = e.target.value ? [e.target.value] : [];
            setSelectedKeys(value);
            handleSearch(e.target.value, dataIndex);
          }}
        />
      </div>
    ),
    filterIcon: () => {
      return (
        <SearchOutlined
          style={{
            color: filters[dataIndex] ? "#1890ff" : undefined,
            fontSize: "16px",
          }}
        />
      );
    },

    render: (text) => {
      return filters[dataIndex] ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[filters[dataIndex]]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        formatText(text, 25) || "N/A"
      );
    },
  });

  const columns = [
    {
      title: "SI",
      dataIndex: "sl",
      width: 40,
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: "Date and Time",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => moment(text).format("DD MMM YYYY, hh:mm A"),
      width: 100,
    },
    {
      title: "Reference ID",
      dataIndex: "referenceId",
      key: "referenceId",
      render: (text) => text || "N/A",
      ...getColumnSearchProps("referenceId", "Reference ID"),
      width: 100,
    },
    // {
    //   title: "Transaction ID",
    //   dataIndex: "transactionId",
    //   key: "transactionId",
    //   render: (text) => text || "N/A",
    //   width: 180,
    // },

    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      width: 100,
      render: (text, record) => (
        <span
          style={{
            color: record?.txnType === "debit" ? "#DC2626" : "#16A34A",
            fontWeight: 500,
          }}
        >
          {record?.txnType === "debit" ? "- " : "+ "} ₹ {text?.toLocaleString()}
        </span>
      ),
    },
    {
      title: "Updated Balance",
      dataIndex: "closingBalance",
      key: "closingBalance",
      width: 100,
      render: (text, record) => {
        let balance =
          (record?.closingBalance || 0) + (record?.closingCreditBalance || 0);
        let adjustedBalance = balance - (record?.creditLimit || 0);
        return `₹ ${adjustedBalance.toFixed(2)}`;
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 200,
      render: (text) => {
        let parsed;

        try {
          parsed = typeof text === "string" ? JSON.parse(text) : text;
        } catch (e) {
          parsed = { message: text };
        }

        return formatText(parsed?.message || "N/A", 80);
      },
    },
    // {
    //   title: "Wallet Type",
    //   dataIndex: "walletType",
    //   key: "walletType",
    //   width: 80,
    //   align: "left",
    //   render: (text) => <div className="wallet-type-tag center">Prepaid</div>,
    // },
  ];

  useEffect(() => {
    if (prospayCustomerId) {
      getTransactions({
        pageNo: pageNum,
        pageSize,
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
      });
    }
  }, [reloadTable, prospayCustomerId]);

  const formatText = (name, charLength = 15) => {
    if (!name) return "N/A";
    return (
      <>
        {name?.length > charLength ? (
          <Tooltip title={name} placement="bottom">
            {name?.length > charLength
              ? `${name?.substring(0, charLength)}..`
              : name}
          </Tooltip>
        ) : (
          name
        )}
      </>
    );
  };

  const getTransactions = async ({ pageNo, pageSize, startDate, endDate }) => {
    setLoading(true);

    //const prospayCustomerId = "SMLNBA000000000599339";
    const formattedStartDate = startDate
      ? moment(startDate).format("YYYY-MM-DD")
      : null;
    const formattedEndDate = endDate
      ? moment(endDate).format("YYYY-MM-DD")
      : null;
    const cleanedFilters = Object.fromEntries(
      Object.entries(filters).filter(
        ([_, value]) => value !== undefined && value !== null && value !== ""
      )
    );
    const queryParams = new URLSearchParams({
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      page: pageNo,
      limit: pageSize,
      ...cleanedFilters,
    }).toString();

    const url = `${GET_WALLET_TRANSACTIONS}${prospayCustomerId}/transactions?${queryParams}`;

    const response = await API.Api(url).getWithToken();
    if (response?.status) {
      setTableData(response?.response?.data?.data);
      setLoading(false);
      setTotalPageSize(response?.response?.data?.count);
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network Error");
    }
  };

  const handleDateChange = (e, date) => {
    setDateRange({ startDate: date[0], endDate: date[1] });
    let temp = {
      pageNo: pageNum,
      pageSize,
      startDate: date[0] || moment(new Date(), dateFormat_dmy),
      endDate: date[1] || moment(new Date(), dateFormat_dmy),
    };
    getTransactions(temp);
    //setFilters(temp);
  };

  const handleTableChange = (pagination) => {
    getTransactions({
      pageNo: pagination?.current,
      pageSize: pagination.pageSize,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    });
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  return (
    <>
      <div className="table-filters flex-end" style={{ marginTop: "-35px" }}>
        <Space>
          <RangePicker
            value={
              dateRange.startDate && dateRange.endDate
                ? [
                    moment(dateRange.startDate, dateFormat_dmy),
                    moment(dateRange.endDate, dateFormat_dmy),
                  ]
                : null
            }
            format={dateFormat_dmy}
            onClick={(e) => e.stopPropagation()}
            onChange={handleDateChange}
            disabledDate={(current) => current && current > moment().endOf("day")}
            // format={dateFormat_dmy}
            className="input-field-style"
            style={{ width: "250px" }}
          />
        </Space>
      </div>
      <Table
        loading={{
          indicator: (
            <img
              src={Smcs_Loader}
              style={{ height: "100px", width: "100px" }}
            />
          ),
          spinning: loading,
        }}
        className="mt-1 wallet-table"
        columns={columns}
        //defaultCurrent={1}
        onChange={handleTableChange}
        dataSource={tableData}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalPageSize,
          pageSizeOptions: ["10", "20", "50", "100"],
          showSizeChanger: true,
          itemRender: itemRender,
        }}
      />
    </>
  );
};

export default Wallet;
